import React from "react";
import { useRef, useState, useEffect } from "react";
import Styles from './NewEditorStyles.module.css'
import { Avatar, Dropdown, Popover, Tooltip } from "antd";
import FontDownloadIcon from "@mui/icons-material/FontDownload";
// import Timer from "../Timer/Timer";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { convertEpochToTimestamp } from "../../utils";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";

import AttachmentBox from "../AttachmentBox/AttachmentBox";
import { Tags } from "../answerBox/TrendingQA/Tags";
import TagComp from "../Tag/TagComp";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import Button2 from "../Button2/Button2";
import Timer from "../../Component/Timer/Timer";
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";
import TooltipComp from "../ToolTip/TooltipComp";


const additionalContextStyles = {
  border: '1px solid rgb(246, 247, 248)',
  marginBlock: '10px',
  borderRadius: '6px',
  background: 'rgb(246, 247, 248)',
  padding: '12px',
  minHeight: '48px',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap'
}


const containerStyle = {
  border: '1px solid #F6F7F8',
  marginBlock: '10px',
  borderRadius: '6px',
  background: '#F6F7F8',
  padding: '12px',
  minHeight: '48px',
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap'
}
const textStyles = {
  fontSize: "14px",
  color: "#2A364A",
  lineHeight: "22px",
  fontWeight: "300",
  display: 'flex',
};
const textStyles2 = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "22px",
  fontWeight: "300",
  display: 'flex',
  // paddingTop: "10px"
  // alignItems:"center"
};
const textStyles1 = {
  fontSize: "24px",
  color: "#2A364A",
  lineHeight: "32px",
  fontWeight: "400",
  wordBreak: 'break-word', overflowWrap: 'break-word',
  paddingTop: "10px"
};
export default function NewTopBar() {
  const editorState = useSelector((state) => state.editor);
  // console.log(editorState.data, 'check data')
  const dispatch = useDispatch();
  const {
    isBackClickedOnRecommend,
    updateQuestiontextForEditor,
    recommendData,
    updatePageNumberExpertOpenTab
  } = bindActionCreators(Actions, dispatch);
  const navigate = useNavigate();

  const textareaRef = useRef(null);
  const [text, setText] = useState(editorState.questionText || "");

  const resizeTextarea = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height
    }
  };
  const onCLickFavorite = () => {
  };
  useEffect(() => {
    setText(editorState.questionText || ""); // Update text when backend data comes
    resizeTextarea(); // Resize when new text arrives
  }, [editorState.questionText]); // Run effect when backend updates `editorState.questionText`

  const handleChange = (e) => {
    setText(e.target.value);
    onChangeQuestionText(e.target.value);
    resizeTextarea(); // Resize on user input
  };

  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("ll");
    }
  };
  const sendToOpenTab = () => {
    updatePageNumberExpertOpenTab(0)
    navigate(-1);
    isBackClickedOnRecommend(true);
    setTimeout(() => {
      isBackClickedOnRecommend(false);
    }, 1000);
  };
  const onChangeQuestionText = (text) => {
    updateQuestiontextForEditor(text);
  };
  const showOtherAnswer = () => {
    let obj = {
      type: "editor",
      quesUuid: editorState.data.questionUuid,
      isUrlRedirection: true,
    };
    recommendData(obj);
    navigate("/expertHome/recommend");
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
        {arr.map((item, index) => (
          <div className="mb-1">
            {" "}
            <AttachmentBox key={index} attachment={item} />
          </div>
        ))}
      </div>
    );
  };


  // console.log("question",editorState?.data?.answers);
  const firstName = editorState?.data?.answers !== undefined && editorState?.data?.answers[0]?.expert?.firstName;
  const lastName = editorState?.data?.answers !== undefined && editorState?.data?.answers[0]?.expert?.lastName;

  return (
    <>
      <div>

        {/* <hr className={Styles.partition} /> */}
        {
            editorState?.data.agenticId !== undefined &&
            <div style={{marginTop:"10px",backgroundColor: "#FFFFFF" }}>
            <span style={{ color: "#ff8000", fontSize: "20px", paddingRight: "5px", marginTop: "12px" }}>Briefing Agent AI Generated Document - Expert Review</span>
            </div>

          }
        <div className={Styles.container} style={{
          alignItems: "flex-start",
          //  paddingTop: "10px" 
        }}>
        

          <div style={{ width: "100%", marginRight: '5px' }}>
            <div style={{
              display: 'flex',
              alignItems: editorState.data.questionStatus === "answered" ? "center" : "baseline"
            }}>
              {editorState.data.questionStatus === "answered" && (
                <div style={textStyles1}>
                  {editorState.data.express && <FireIcon style={{ marginRight: '5px', }} />}
                  <FontDownloadIcon
                    onClick={() => showOtherAnswer()}
                    sx={{
                      fontSize: "24px",
                      color: "rgb(190, 219, 57)",
                      cursor: "pointer",
                    }}
                  />
                  &nbsp;
                  <span style={textStyles1}>
                    {editorState.questionText}
                  </span>

                </div>


              )}
              {editorState.data.questionStatus === "open" && editorState.data.otherLanguageQuestionText !== undefined && editorState.data.otherLanguageQuestionText !== null && (
                //   <span className={Styles.alignDiv}>
                //     {editorState.data.express && <img
                //   src={require("../../Images/fire.png")}
                //   alt="fire"
                //   style={{ width: "30px", height: "30px" }}
                // />}
                //    {editorState.questionText}
                //   </span>


                <div style={textStyles1}>

                  {editorState.data.express && (
                    <>
                      <FireIcon style={{ marginRight: '5px', }} />
                    </>
                  )}
                  {/* <span></span> */}
                  {editorState.questionText}

                </div>

              )}

              {editorState.data.questionStatus === "open" && (editorState.data.otherLanguageQuestionText === undefined || editorState.data.otherLanguageQuestionText === null) && (
                <div style={{ width: '100%', textAlign: "center", justifyContent: "center" }}>
                  <div style={textStyles2}>
                    {editorState.data.express && <FireIcon style={{ marginRight: '5px', marginTop: "10px" }} />}
                    {/* <textarea wrap="soft" style={{ border: '1px solid rgb(224, 226, 230)', width: '100%', padding: '12px', borderRadius: '6px', outline: 'none', resize: 'none' ,  fontSize: "16px",color: "#2A364A",}} rows={2} type={"text"} value={editorState.questionText} onChange={(e) => onChangeQuestionText(e.target.value)} /> */}
                    <textarea
                      ref={textareaRef}
                      style={{
                        border: "1px solid rgb(224, 226, 230)",
                        width: "100%",
                        padding: "12px",
                        borderRadius: "6px",
                        outline: "none",
                        // resize: "none",

                        fontSize: "16px",
                        color: "#2A364A",
                        overflow: "hidden", // Prevent scrollbar
                      }}
                      rows={1}
                      value={text}
                      onChange={handleChange}
                    />
                  </div>
                </div>

              )}
              {/*  */}
              {/* <div>
                attachemets
              </div> */}




            </div>
            {editorState.data.additionalContext && (
              <div style={additionalContextStyles}>
                {editorState.data.additionalContext}
              </div>
            )}
            <div>




            </div>


            {/* {editorState?.seekerAttachments !== undefined && editorState?.seekerAttachments?.length > 0 &&
              <div className="mt-1">
    
                {editorState.seekerAttachments && editorState.seekerAttachments.length > 0 && (
                  <Popover title={renderAttachemnt(editorState.seekerAttachments)}>
                    {" "}
                    <Button2 >
                      <DownloadIcon />
                    </Button2>
                  </Popover>)}
              </div>
            } */}

            {/* <Tags data={editorState.data}/> */}

            <div style={containerStyle} >
              {editorState.data.domain !== undefined && <div style={textStyles}>Domains&nbsp; <TagComp title={editorState.data.domain} />&nbsp;&nbsp;</div>}
              {
                // <TooltipComp  title={`${editorState.data.postedUserFirstName} ${editorState.data.postedUserLastName}`}>
                <div style={textStyles}> Asked by&nbsp; <TooltipComp title={`${editorState.data.postedUserFirstName !== undefined ? editorState.data.postedUserFirstName : firstName} ${editorState.data.postedUserLastName !== undefined ? editorState.data.postedUserLastName : lastName}`}><span><TagComp title={editorState.data.userType !== undefined || null ? editorState.data.userType : "Employee"} /></span></TooltipComp>&nbsp;&nbsp;</div>

                //  </TooltipComp>
              }
              {<div style={textStyles}> Asked&nbsp;{momentit(editorState.data.questionPostedTimestamp)}&nbsp;&nbsp;</div>}
              {/* {
              editorState?.seekerAttachments &&
              editorState?.seekerAttachments.length > 0 && (
                <div >
                  {renderAttachemnt(editorState?.seekerAttachments)}
                </div>
              )} */}

              {/* {editorState.data.length!== 0 && <div style={textStyles}>Tags:{editorState.data.map(tag=>{
                        if(tag.clickable){
                            return <TagComp key={tag.term} title={tag.term} />
                        }
                    })}</div>} */}
            </div>
            {editorState.data.url !== undefined && editorState.data.url !== null && <div style={containerStyle} >
              <div style={textStyles}> URL:&nbsp;<a href={editorState.data.url} target="_blank">{editorState.data.url}</a></div>

              {/* {editorState.data.length!== 0 && <div style={textStyles}>Tags:{editorState.data.map(tag=>{
                        if(tag.clickable){
                            return <TagComp key={tag.term} title={tag.term} />
                        }
                    })}</div>} */}
            </div>}
            {
              editorState?.seekerAttachments &&
              editorState?.seekerAttachments.length > 0 && (
                <div style={containerStyle}>
                  {renderAttachemnt(editorState?.seekerAttachments)}
                </div>
              )}
            {/* <div
              className="mt-2"
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "13px",
                color: "grey",
              }}
            >
              <p>
                Domain:&nbsp;
                <span className={Styles.tags}>{editorState.data.domain}</span>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </p>
              <p>
                Asked by:&nbsp;
                <Tooltip
                  title={`${editorState.data.postedUserFirstName} ${editorState.data.postedUserLastName}`}
                  placement="right"
                  arrow
                >
                  <span className={Styles.tags}>Employee</span>
                </Tooltip>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </p>
              <p>
                Asked:&nbsp;
                <span>
                  {momentit(editorState.data.questionPostedTimestamp)}
                </span>
              </p>
            </div> */}
          </div>

          <div style={{ textAlign: "center", marginTop: "15px" }}>
            {editorState.data.expireSLA / 60 <=
              editorState.data.routingPeriod &&
              editorState.data.expireSLA > 0 && <Timer />}
          </div>
        </div>
      </div>
    </>
  );
}
